import {
  FETCH_ALTERNATIVES_REQUEST,
  FETCH_ALTERNATIVES_SUCCESS,
  FETCH_ALTERNATIVES_FAILURE,
  UPDATE_ALTERNATIVES
} from '../../actionTypes/alternativesActionTypes'

const fetchAlternativesRequest = payload => {
  const { partNumber, localisation = {}, categoryId, type } = payload
  const action = {
    type: FETCH_ALTERNATIVES_REQUEST,
    payload: {
      type,
      partNumber,
      localisation,
      categoryId
    }
  }
  return action
}

const fetchAlternativesSuccess = payload => {
  const action = {
    type: FETCH_ALTERNATIVES_SUCCESS,
    payload
  }
  return action
}

const fetchAlternativesFailure = ({ partNumber, errorDetail }) => {
  const action = {
    type: FETCH_ALTERNATIVES_FAILURE,
    payload: { partNumber, errorDetail: errorDetail.toString() }
  }
  return action
}

const updateAlternatives = payload => {
  const action = {
    type: UPDATE_ALTERNATIVES,
    payload
  }
  return action
}

export { fetchAlternativesRequest, fetchAlternativesSuccess, fetchAlternativesFailure, updateAlternatives }
